import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Field as AvField, Form as AvForm } from "@availity/form"
import { Button, FormGroup, Label } from "reactstrap"
import * as yup from "yup"

import { useWallet } from "../../libs/useMetaMaskWallet"
import subdomains from "../../constants/subdomains.json"
import { contracts } from "../../Pages/NFTSale/utils"
import { networkIcons } from "../../utils"
import ConfirmSubmitModal from "../ConfirmSubmitModal/ConfirmSubmitModal"
import CustomTooltip from "../Tooltip"
import "./SwagCard.scss"

import { approveSpender, buyItem } from "../../Pages/SwagSalePage/utils"

const SwagCard = ({ item, idx, subdomain, allowance, balance, enableClickItem = true, ItemIsPurchased = false, contractType }) => {
    // if purchased == true lootbox has ben purchased, if false lootbox is available for purchase
    const wallet = useWallet()

    const collectionAddress = "0xdC8050Fc5B3aD354484f5DC7e50fF0A05FF80797"
    const chain = 324
    const contractOwner = ""
    const collectionSymbol = "HSS"

    const [showImageLoading, setShowImageLoading] = useState(true)
    const [quantity, setQuantity] = useState(0) // quantity of swag nft to purchase
    const [showBtnSpinner, setShowBtnSpinner] = useState(false) // loading animation on approve/purchase button
    const [itemIsClickable, setItemIsClickable] = useState(enableClickItem) // if true, clicking lootboxcard loads lootboxDetail page
    const [showConfirmSubmitModal, setShowConfirmSubmitModal] = useState(false) // when user clicks on "approve" or "purchase", this modal shows
    const [modalAlertMessage, setModalAlertMessage] = useState("")
    const [alertColor, setAlertColor] = useState("")
    const [disableModalButtons, setDisableModalButtons] = useState(false)
    const [showConfirmLoading, setShowConfirmLoading] = useState(false)

    const [buyTx, setBuyTx] = useState(null)

    // console.log("lootbox card", lootbox)
    // console.log("buyTx", buyTx)

    const confirmApprovePurchase = async (type) => {
        console.log(type)
        setShowConfirmLoading(true)
        setDisableModalButtons(true)

        switch (type) {
            case "APPROVE":
                console.log("Call Approve")
                const approveTx = approveSpender(wallet, setDisableModalButtons, setShowConfirmLoading)
                break
            case "PURCHASE":
                console.log("Call Purchase")
                const buyTx = buyItem(wallet, item?.name, setDisableModalButtons, setShowConfirmLoading, setBuyTx)
                break

            default:
                setShowConfirmLoading(false)
                setDisableModalButtons(false)
                break
        }
    }

    const handleClickItemCard = (e) => {
        // console.log("e?.target?.lastChild?.innerHTML", e?.target?.lastChild?.innerHTML)
        // console.log("e?.target?.innerHTML", e?.target?.innerHTML)
        // console.log("e?.target?.lastChild?.localName", e?.target?.lastChild?.localName)

        const buttonTxt = e?.target?.lastChild?.innerHTML

        // if user clicks input quantity form
        if (e?.target?.localName === "input") e.preventDefault() // prevent redirect to lootboxDetails page

        if (buttonTxt === "INSUFFICIENT BALANCE") e.preventDefault()

        // clicking "approve" or "purchase" button
        if (e?.target?.innerHTML === "APPROVE" || e?.target?.innerHTML === "PURCHASE" || buttonTxt === "APPROVE" || buttonTxt === "PURCHASE") {
            // e.preventDefault()
            // // check if quantity is valid integer
            // if (Number(quantity) > 0 && Number.isInteger(Number(quantity))) setShowConfirmSubmitModal(true)
            setShowConfirmSubmitModal(true)
        }
    }

    useEffect(() => {
        console.log("item " + JSON.stringify(item))
    }, [])

    return (
        <React.Fragment>
            <div className="loot-box-card">
                <div className={"image-wrap"}>
                    <img
                        src={item?.imgUrl}
                        width="200px"
                        onLoad={() => setShowImageLoading(false)}
                        alt={subdomain + " swag item"}
                        className={"lootbox-img" + (showImageLoading ? " hide" : "")}
                    />
                </div>

                {/* <div className="lootbox-chain-wrap">
                            <img src={networkIcons["zksync"]} alt={"zksync"} />
                            <span>{"zksync"}</span>
                            </div> */}
                {/* </div> */}

                <AvForm
                    className="purchase-form-wrap"
                    enableReinitialize
                    // NOTE* initialValue key's must match "name" attribute value in AvField components!
                    initialValues={{ quantity: quantity }}
                    validationSchema={yup.object().shape({
                        quantity: yup
                            .number()
                            .required("This field is required.")
                            // if callback in .test returns false, show error message
                            .test("valid quantity?", "Must be a positive integer", (num) => Number.isInteger(num) && Number(num) > 0)
                    })}
                >
                    <div className="lootbox-name">{item?.name}</div>

                    <div className="lootbox-cost">
                        <span className="lootboxcard-label-title">COST:</span>
                        <span className="lootboxcard-label-value">
                            $ {item?.itemPrice} {balance?.symbol}
                        </span>
                    </div>

                    <FormGroup className="mb-3">
                        <AvField
                            name="quantity"
                            label="Quantity"
                            placeholder="Enter Number"
                            type="number"
                            className="form-control"
                            disabled={showBtnSpinner}
                            min={0}
                            onChange={(e) => setQuantity(e.target.value)}
                            onMouseEnter={() => setItemIsClickable(false)}
                            onMouseLeave={() => {
                                if (enableClickItem) setItemIsClickable(true)
                            }}
                        />
                    </FormGroup>

                    <div className="lootbox-total-cost">
                        <span className="lootboxcard-label-title">TOTAL:</span>
                        <span className="lootboxcard-label-value">
                            $ {Number(item?.itemPrice) * quantity} {balance?.symbol}
                        </span>
                    </div>

                    <Button
                        color="primary"
                        type="submit"
                        onClick={handleClickItemCard}
                        disabled={quantity < 1 || Number(item?.itemPrice * quantity) > Number(balance?.balance)}
                        className="approve-purchase-btn"
                        onMouseEnter={() => setItemIsClickable(true)}
                        onMouseLeave={() => {
                            if (enableClickItem) setItemIsClickable(true)
                        }}
                    >
                        {Number(item?.itemPrice * quantity) > Number(balance?.balance)
                            ? "INSUFFICIENT BALANCE"
                            : Number(item?.itemPrice * quantity) > Number(allowance)
                              ? `APPROVE`
                              : `PURCHASE`}
                    </Button>
                </AvForm>
            </div>

            {/* CONFIRM APPROVE or PURCHASE MODAL */}
            {showConfirmSubmitModal && (
                <ConfirmSubmitModal
                    showConfirmSubmitModal={true}
                    setShowConfirmSubmitModal={setShowConfirmSubmitModal}
                    modalAlertMessage={modalAlertMessage}
                    setModalAlertMessage={setModalAlertMessage}
                    alertColor={alertColor}
                    setAlertColor={setAlertColor}
                    disableAllButtons={disableModalButtons}
                    showConfirmLoading={showConfirmLoading}
                    handleClickConfirm={
                        buyTx
                            ? () => confirmApprovePurchase("CLOSE")
                            : Number(item?.itemPrice * quantity) > Number(balance?.balance)
                              ? "INSUFFICIENT BALANCE"
                              : Number(item?.itemPrice * quantity) > Number(allowance)
                                ? () => confirmApprovePurchase("APPROVE")
                                : () => confirmApprovePurchase("PURCHASE")
                    }
                    modalTitle={Number(item?.itemPrice * quantity) > Number(allowance) ? "Confirm Item Approval" : "Purchase Item"}
                    confirmButtonText={
                        buyTx
                            ? "CLOSE"
                            : Number(item?.itemPrice * quantity) > Number(balance?.balance)
                              ? "INSUFFICIENT BALANCE"
                              : Number(item?.itemPrice * quantity) > Number(allowance)
                                ? `APPROVE`
                                : `PURCHASE`
                    }
                    confirmButtonLoading={Number(item?.itemPrice * quantity) > Number(allowance) ? "APPROVING" : `PURCHASING`}
                >
                    {!buyTx && Number(item?.itemPrice * quantity) > Number(allowance) && (
                        <div className="clicking-approve-txt">
                            Clicking approve calls a method on the currency contract to allow the sale contract to spend your wallet funds
                        </div>
                    )}

                    <div className="modal-lootbox-name">
                        <span className="modal-label">Loot Box Name:</span> {item?.name}
                    </div>
                    <div className="modal-lootbox-cost">
                        <span className="modal-label">Cost:</span> $ {item?.itemPrice} {balance?.symbol}
                    </div>
                    <div className="modal-lootbox-quantity">
                        <span className="modal-label">Quantity:</span> {quantity}
                    </div>
                    <div className="modal-lootbox-total">
                        <span className="modal-label">Total:</span> $ {Number(item?.itemPrice) * quantity} {balance?.symbol}
                    </div>
                    <img src={item?.imgUrl} alt={subdomain + " lootbox"} className="lootbox-img-modal" />
                    {buyTx && (
                        <div className="tx-hash">
                            <span className="modal-label">Purchase Tx Hash: </span>
                            <span className="tx-hash-val">{buyTx}</span>
                        </div>
                    )}
                </ConfirmSubmitModal>
            )}
        </React.Fragment>
    )
}

export default SwagCard
